module.exports = __webpack_public_path__ + "img/2023Calendar.b1a160a7.png";